import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import type { NavbarMenuBurgerContentElementProps } from '../../navbarElement/Navbar.type';
import { getBackgroundColorStyle } from '../../utils/background';
import * as styles from '../Navbar.css';

const DEFAULTS = {
  background: '#ffffff',
  padding: '16px',
  gap: '8px',
  border: 'none',
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'none',
  borderRadius: '0px',
};

export function NavbarMenuBurgerContentV2(props: NavbarMenuBurgerContentElementProps) {
  const { element, children, className, attributes } = props;
  const { customAttributes, background, padding, gap, border, borderColor, borderWidth, borderStyle, borderRadius } =
    element.attrs || {};
  const { height, ref: contentRef } = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 100,
  });

  const isOpen = attributes?.['data-is-open'] === true;

  return (
    // biome-ignore lint/a11y/useValidAriaRole: none
    <div
      {...props}
      role="none"
      {...customAttributes}
      {...attributes}
      className={classNames(styles.navbarMenuBurgerContentV2)}
      style={
        {
          width: '100vw',
          maxHeight: isOpen ? `min(${1000 - (height ?? 0)}px, calc(100vh - ${height ?? 0}px))` : '0px',
          height: isOpen ? 'auto' : '0px',
          overflow: isOpen ? 'auto' : 'hidden',
          opacity: isOpen ? 1 : 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'start',
          ...getBackgroundColorStyle(background ?? DEFAULTS.background),
        } as CSSProperties
      }
    >
      {/* biome-ignore lint/a11y/useValidAriaRole: none */}
      <div
        ref={contentRef}
        role="none"
        className={classNames(styles.navbarMenuBurgerContentInnerV2, className, customAttributes?.className)}
        style={
          {
            width: '100%',
            '--padding': padding ?? DEFAULTS.padding,
            '--gap': gap ?? DEFAULTS.gap,
            border: border ?? DEFAULTS.border,
            borderColor: borderColor ?? DEFAULTS.borderColor,
            borderWidth: borderWidth ?? DEFAULTS.borderWidth,
            borderStyle: borderStyle ?? DEFAULTS.borderStyle,
            borderRadius: borderRadius ?? DEFAULTS.borderRadius,
          } as CSSProperties
        }
      >
        {children}
      </div>
    </div>
  );
}
